export const BANNER_CONTENT = `
Thank you for taking the time to explore my website.

If you think it's interesting and want to see the code behind it,
I've placed it in the open at https://github.com/samlkey-labs/portfolio.
Feel free to check it out!
`;
